// url에 있는 파라미터 가져오기
const GetUrlParams = () => {
  var params = {};
  window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(
    str,
    key,
    value
  ) {
    params[key] = value;
  });
  return params;
};

export { GetUrlParams };
